import { Box as MuiBox, Typography } from '@mui/material';

import { TransferArrow } from '../icons';

interface Props {
  from: string;
  to?: string;
}

const ellipsis = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** The account the money leaves, then the one it enters, smaller and with an arrow. */
const TransferAccounts = ({ from, to }: Props) => (
  <MuiBox sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
    <MuiBox component="span" title={from} sx={ellipsis}>
      {from}
    </MuiBox>
    <Typography
      variant="caption"
      component="span"
      title={to}
      sx={{
        ...ellipsis,
        display: 'flex',
        alignItems: 'center',
        color: 'text.secondary',
        lineHeight: 1.2,
      }}
    >
      <TransferArrow sx={{ fontSize: 16, flexShrink: 0, ml: -0.5 }} />
      {to}
    </Typography>
  </MuiBox>
);

export default TransferAccounts;
